'use client';

import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { SCROLL_TO_TOP_ICON_HIDDEN_PAGE_LIST } from '@/utils/constants';
import { EPlatform } from '@/utils/enums/platform-enum';
import { env } from '@/utils/env';
import { JumpToTopOutlined } from '@zeelool/icon';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { useContext } from 'react';
const Coupon = dynamic(() => import('./components/Coupon'), {
  ssr: false,
});
const AppDownloadGuide = dynamic(() => import('./components/AppdownloadGuide'), {
  ssr: false,
});
const CustomerService = dynamic(() => import('./components/CustomerService'), {
  ssr: false,
});
const Unpaid = dynamic(() => import('./components/Unpaid'), {
  ssr: false,
});
const RightBottomFloating = () => {
  const isShowScrollToTop = useStore((state) => state.isShowScrollToTop);
  const isHalfStickyRightBottomIcons = useStore((state) => state.isHalfStickyRightBottomIcons);
  const pathname = usePathname();
  const { deviceType } = useContext(ResponsiveContext);
  const inAppH5 = [EPlatform.ANDROID, EPlatform.IOS].includes(deviceType);

  // Check if current page is shopping cart
  const isCartPage = pathname === '/cart';

  // Handle scroll to top
  const handleScrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    // wap 端改成 64px 是考虑到客服图标下面有个外间距 12px
    <div
      className={`
        fixed right-[14px] lg:right-[20px] bottom-[76px] lg:bottom-[56px] z-[350] transition-all duration-300 ease-in-out flex flex-col justify-center items-center
        ${isHalfStickyRightBottomIcons ? '!right-[-23px] lg:right-[-30px]' : ''}
        ${isCartPage ? '!bottom-[110px]' : ''}
      `}
    >
      {/* 优惠券 - 只在非 App 环境显示 */}
      {<Coupon />}

      {/* App 下载指引 - 只在 PC 端显示 */}
      {env.NEXT_PUBLIC_HAS_APP === 'true' && (
        <WebOnly>
          <AppDownloadGuide />
        </WebOnly>
      )}

      {/* 客服 */}
      <CustomerService />

      {/* 未支付订单 - 自管理显示逻辑 */}
      <Unpaid />

      {/* 回到顶部 */}
      <div
        className={`
        w-[44px] h-[44px] mb-[12px]
        bg-white
        shadow-[0px_4px_10px_0px_rgba(25,25,26,0.12)]
        flex justify-center items-center
        rounded-full
        cursor-pointer
        hover:shadow-[0px_6px_15px_0px_rgba(25,25,26,0.18)]
        active:scale-95
        ${!isShowScrollToTop || inAppH5 || SCROLL_TO_TOP_ICON_HIDDEN_PAGE_LIST.includes(pathname) ? 'hidden' : 'visible'}
      `}
        onClick={handleScrollToTop}
        aria-label="Scroll to top"
      >
        <JumpToTopOutlined className="text-[24px] text-primary-black z-[100]" />
      </div>
    </div>
  );
};

export default RightBottomFloating;
